<div class="prevent__popin">
  <div class="prevent__popin__title vc-text-l" i18n="@@GET_PAID.PREVENT_CLOSE_POPIN.TITLE">
    Are you sure you want to quit?
  </div>
  <div class="prevent__popin__content vc-text-m" i18n="@@GET_PAID.PREVENT_CLOSE_POPIN.CONTENT">
    All information that you filled in this page will be lost.
  </div>
  <button
    class="vc-btn vc-btn--outline vc-btn--medium quitButton"
    (click)="close(true)"
    i18n="@@GET_PAID.PREVENT_CLOSE_POPIN.BUTTON_QUIT"
  >
    Quit
  </button>
  <button
    class="vc-btn vc-btn--primary vc-btn--medium "
    (click)="close(false)"
    i18n="@@GET_PAID.PREVENT_CLOSE_POPIN.BUTTON_BACK"
  >
    Go back
  </button>
</div>
